import { SESSION_LENGTH_OPTIONS, normalizeSessionLengthSelection } from '../utils/sessionLength';

function SessionLengthSelector({
  value,
  onChange,
  title = 'Session length',
  description = 'Choose how long this practice session should run.',
  className = '',
  name = 'session-length',
}) {
  const normalized = normalizeSessionLengthSelection(value);

  return (
    <fieldset className={`session-length-selector ${className}`.trim()}>
      <legend>{title}</legend>
      {description ? <p className="session-length-selector-description">{description}</p> : null}
      <div className="session-length-selector-options" role="radiogroup" aria-label={title}>
        {SESSION_LENGTH_OPTIONS.map((option) => {
          const checked = normalized.questionCountMode === option.questionCountMode
            && (option.questionCountMode === 'endless' || normalized.questionCount === option.questionCount);
          return (
            <label key={option.key} className={`session-length-option ${checked ? 'is-selected' : ''}`}>
              <input
                type="radio"
                name={name}
                value={option.key}
                aria-label={option.label}
                checked={checked}
                onChange={() => onChange({
                  questionCountMode: option.questionCountMode,
                  questionCount: option.questionCount,
                })}
              />
              <span className="session-length-option-body">
                <span className="session-length-option-label">{option.label}</span>
                <span className={`session-length-option-helper${option.helperText ? '' : ' is-placeholder'}`}>
                  {option.helperText || ' '}
                </span>
              </span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}

export default SessionLengthSelector;
